// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"uselect_wrapper_2sRVZ"};